// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__4YsOv","aside":"sidebar_aside__zLsKY"};